import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 20.947 17.57"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", {
  id: "Group_2716",
  transform: "translate(-113.053 -1003.93)"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_2247",
    d: "M13.5 18.469H3V3.6h10.5v5.408H15V3.6a1.432 1.432 0 0 0-1.5-1.35H3A1.432 1.432 0 0 0 1.5 3.6v14.869A1.432 1.432 0 0 0 3 19.82h10.5a1.432 1.432 0 0 0 1.5-1.351v-5.406h-1.5z",
    class: "cls-1",
    transform: "translate(111.553 1001.68)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "Path_2248",
    d: "m22.5 12-5.25-3.75v3H6.75v1.5h10.5v3z",
    class: "cls-1",
    transform: "translate(111.5 1000.715)"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };